// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Z3ow","icon":"styles_icon__3-BMx"};